import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['itemsCount'];
  static values = {
    isMobile: false,
    cartIconUrl: '/cart'
  };

  declare itemsCountTarget: HTMLElement;
  declare hasItemsCountTarget: boolean;

  declare cartIconUrlValue: string;
  declare isMobileValue: boolean;

  connect(): void {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile.bind(this));
  }

  checkMobile() {
    this.isMobileValue = window.innerWidth < 1024;
  }

  setItemsCount({ detail: { itemsCount } }) {
    const emptyCartClass = 'cart-empty';
    const classAction = itemsCount === '0' ? 'add' : 'remove';
    const selector = `[data-${this.identifier}-target~="itemsCount"]`;
    const itemsCountTarget = this.hasItemsCountTarget
      ? this.itemsCountTarget
      : this.element?.parentNode?.querySelector(selector);

    if (itemsCountTarget) {
      itemsCountTarget.textContent = itemsCount;
      itemsCountTarget.classList[classAction](emptyCartClass);
    }
  }

  handleMouseEnter() {
    if (!this.isMobileValue) {
      const event = new CustomEvent('openCart');
      window.dispatchEvent(event);
    }
  }

  handleCartIconClick() {
    if (this.cartIconUrlValue) {
      window.location.href = this.cartIconUrlValue;
    }
  }
}
